module.exports = __webpack_public_path__ + "img/ai_system.c7194700.jpg";